
import React from 'react';

export const TechniquesLoadingState: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[...Array(3)].map((_, index) => (
        <div key={index} className="h-80 bg-muted/40 animate-pulse rounded-xl" />
      ))}
    </div>
  );
};
